import React from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import { Provider as AnalyticsProvider } from '@carvana/analytics';
import ThemeProvider, {
  CarvanaTheme,
  createGlobalStyle as createCarvanaGlobalStyle,
} from '@carvana/theme';
import store, { history } from './store/configureStore';
import configs from './store/configs';
import Layout from './components/Layout';
import ErrorBoundary from './components/ErrorBoundary';
import ErrorPage from './components/ErrorPage';
import Routes from './Routes'

const GlobalStyle = createGlobalStyle`
html, body {
  margin: 0;
}
body {
  overflow-x: hidden;
}
h1, h2, h3, h4, p {
  font-family: 'Brandon Text', Lato, sans-serif;
}
`;
const CarvanaGlobalStyle = createCarvanaGlobalStyle(process.env.NODE_ENV, `
  @font-face {
    font-family: 'Brandon Text';
    font-display: auto;
    font-weight: 300;
    font-style: normal;
    font-style: normal;
    src: url("${process.env.CARVANA_APP_CDN_URL}/fonts/BrandonText-Light.otf");
  }
  @font-face {
    font-family: 'Brandon Text';
    font-display: auto;
    font-weight: 400;
    font-style: normal;
    src: url("${process.env.CARVANA_APP_CDN_URL}/fonts/BrandonText-Regular.otf");
  }
  @font-face {
    font-family: 'Brandon Text';
    font-display: auto;
    font-weight: 700;
    font-style: normal;
    src: url("${process.env.CARVANA_APP_CDN_URL}/fonts/BrandonText-Bold.otf");
  }
  @font-face {
    font-family: 'Brandon Text Black';
    font-display: auto;
    font-weight: 700;
    font-style: normal;
    src: url("${process.env.CARVANA_APP_CDN_URL}/fonts/BrandonText-Black.otf");
  }


`);

const customTheme = {
  ...CarvanaTheme,
  jj: {
    blue: {
      dark: '#0D375E',
      medium: '#1971C2',
      primary: '#228BE6',
    },
    yellow: {
      dark: '#FAB005',
      primary: '#FFD43B',
    },
  },
}

export default () => (
  <>
    <Provider store={store}>
      <ThemeProvider theme={customTheme}>
        <CarvanaGlobalStyle />
        <GlobalStyle />
        <AnalyticsProvider configs={configs}>
          <Layout>
            <ErrorBoundary FallbackComponent={() => <ErrorPage />}>
              <Router history={history} basename='/share'>
                <Routes />
              </Router>
            </ErrorBoundary>
          </Layout>
        </AnalyticsProvider>
      </ThemeProvider>
    </Provider>
  </>
);
